module.exports = __webpack_public_path__ + "img/Armenia.d990b457.svg";